module.exports = __webpack_public_path__ + "img/suds.86eeccd3.svg";